export default "__VITE_ASSET__Chq46hlw__"